import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Brepingtable1 from '../../component/Brepingtable1';
import Mainbanners from '../../component/Mainbanners';
import MainbannersTable from '../../component/MainbannersTable';
import Select from '../../component/Select';
import { getMemberinfo, numFormat, useIntersectionObserver, polygon_point_check } from "../../utils/utils";

import * as APIS from "../../utils/service";
import Checkbox from '../../component/Checkbox';

export default function Deletelist({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const target = useRef(null);
    const { configdata } = useSelector(s => s.configReducer);
    let statusArrs = [];
    configdata?.consts?.itemStatusConsts?.map((x, i) => {
        if(x?.idx*1 === 98){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'green', 'no', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 1){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'black', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 2){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'blue', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 3){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'red', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else {
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'y', x?.idx], labels: x?.title, values: x?.idx});
        }
    });
    const statusName = statusArrs;

    const [memberinfos, setmemberinfos] = useState(''); 

    const [seldamdang, setseldamdang] = useState(''); 
    const [damdanglist, setdamdanglist] = useState([]); 
    const [lists, setlists] = useState([]); 
    const [savelists, setsavelists] = useState([]); 
    
    const [page, setPage] = useState(0);   
    const [checkvalues, setcheckvalues] = useState([]);   
    const [allcheckvalues, setallcheckvalues] = useState([]);   
    const [popflag, setpopflag] = useState(false); 
    const [thisdamdang, setthisdamdang] = useState(''); 
    const [errormsg, seterrormsg] = useState(''); 
    

    
    const [observe, unobserve] = useIntersectionObserver(() => {
        setPage((page) => page + 1);
    });

    useEffect(() => {
        if(lists?.length > 0 && lists?.length === checkvalues?.length){
            setallcheckvalues([{names: '', values: '전체'}]);
        } else {
            setallcheckvalues([]);
        }
    }, [checkvalues]);
    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
    useEffect(() => {
        let sender = {}
        APIS.postData('/v1/master/users', sender).then(({ data }) => {
            if(data){
                //setdamdanglist(data);
                console.log(data);
                let damdanglistArr = [];
                data?.map((x, i) => {
                    damdanglistArr.push({labels: `${x?.name} ${x?.rank}`, values: x?.idx});
                })
                setdamdanglist(damdanglistArr);

            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
        });  
    }, []);
    
    
    useEffect(() => {
        searchSetlist();
    }, [
        seldamdang
    ]);

    const searchSetlist = () => {
        let listSearchArr = savelists;
        if(seldamdang*1 > 0){
            listSearchArr = listSearchArr?.filter(item => item?.u_idx*1 === seldamdang*1 );
        }
        setlists(listSearchArr);
    }
    useEffect(() => {
        listopen();
        setPage(1);
        observe(target.current);
    }, []);
    const listopen = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            rolling: false
        }
        APIS.postData('/v1/item/deleteList', sender).then(({ data }) => {
            if(data){
                setlists(data);
                setsavelists(data);
                //console.log(data);

            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });           
    }
    const productrestore = () => {
        let senderidxs = [];
        checkvalues?.map((x, i) => {
            senderidxs.push(x?.values);
        });
        console.log(checkvalues, senderidxs, thisdamdang);

        dispatch(loadingflas({ loading: true }));
        let sender = {
            idxs: senderidxs,
            u_idx: memberinfos?.level*1 === 3 ? thisdamdang : memberinfos?.idx
        }
        APIS.postData('/v1/item/restore', sender).then(({ data }) => {
            if(data){
                listopen();
                setpopflag(false);
                setthisdamdang('');
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });   
    }
    return(
        <>
        <Layout header={false} actives={'0'}>
            <div className='section1250'>
                <div className="bgareastyle1 padding32 margint25">
                    <div className='backbuttonarea' style={{ borderBottom: 0, marginBottom: 10 }}>
                        <div>
                            <button onClick={() => { navigate(-1); }}>
                                <img src={`./images/icons/back.svg`} /> 
                            </button>
                            <span className='fontsize16 bolds'>삭제된 매물</span>
                        </div>
                    </div>
                    <div className="listselecter" style={{ marginTop: 0 }}>
                        <div>
                            {memberinfos?.level*1 === 3 &&
                            <div>
                                <Select 
                                    setValues={setseldamdang}
                                    values={seldamdang}
                                    selectData={( [{labels: '전체', values: ''}].concat(damdanglist) )}

                                />
                            </div>              
                            }
                            
                        </div>
                        <div>
                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 10}}>
                                <div>삭제된 매물은 30일간 확인 가능하며, 이후 완전히 삭제됩니다.</div>            
                                <Button
                                    onPress={() => {
                                        if(memberinfos?.level*1 === 3){
                                            setpopflag(true);
                                        } else {
                                            if(checkvalues?.length === 0){
                                                dispatch(
                                                    open({
                                                        component: `복원할 매물을 선택해주세요.`,
                                                        title: '알림',
                                                        titleviewer: true,
                                                        alert: false,
                                                        button: "확인",
                                                        onPress: () => {
                                                            dispatch(close());
                                                        }
                                                    })
                                                ); 
                                                return;

                                            }

                                            productrestore();
                                        }
                                    }}              
                                    styles={{ width: 120, height: 40, fontSize: 14 }}      
                                    buttonTxt={'매물 복원'}
                                />
                            </div>    
                        </div>
                    </div>

                    <div
                        className='product_scroll_list_div'
                        style={{ width: '100%' }}
                    >
                        <table 
                            style={{ width: '100%', }}
                            className='tablelistarea'
                        >
                            <thead 
                                style={{
                                    backgroundColor: '#F2F4F7',
                                    textAlign: "center",
                                    position: "sticky",
                                    top: "0",
                                    border: '1px solid red',
                                    zIndex: 1
                                }}                        
                            >
                                <tr>
                                    <th style={{ minWidth: 30, paddingLeft: 5}}>
                                        <Checkbox
                                            linetype={'checkimg'}
                                            values={allcheckvalues}
                                            setvalues={(e) => {
                                                setallcheckvalues(e);
                                                if(e?.length > 0){
                                                    let checkvaluesAll = [];
                                                    lists?.map((x, i) => {
                                                        checkvaluesAll.push({names: '', values: x?.idx})
                                                    })
                                                    setcheckvalues(checkvaluesAll);
                                                } else {
                                                    setcheckvalues([]);
                                                }
                                            }}
                                            namevalue={[
                                                {names: '', values: '전체'},
                                            ]}
                                            fontweights={400}
                                            fontSizes={14}
                                            sizes={20}
                                        />                                         
                                    </th>
                                    <th>담당자</th>
                                    <th>삭제일</th>
                                    <th>상태</th>
                                    <th>매물번호</th>
                                    <th>확인일</th>
                                    <th>읍/면/동</th>
                                    <th>지번</th>
                                    <th>전용</th>
                                    <th>종류</th>
                                    <th>가격</th>
                                    <th>관리비</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lists?.length > 0 && lists?.map((x, i) => {
                                    
                                    if(i > (page*10)){
                                        return;
                                    }
                                    let productCode = ('0000000'+x?.idx).slice(-7);
                                    return (
                                        <tr key={i}>
                                            <td  style={{ minWidth: 30 }}>
                                                <Checkbox
                                                    linetype={'checkimg'}
                                                    values={checkvalues}
                                                    setvalues={(e) => {
                                                        setcheckvalues(e);
                                                    }}
                                                    namevalue={[
                                                        {names: '', values: x?.idx},
                                                    ]}
                                                    fontweights={400}
                                                    fontSizes={14}
                                                    sizes={20}
                                                />  
                                            </td>
                                            <td>
                                                {x?.user?.name} {x?.user?.rank}
                                            </td>
                                            <td>
                                                {moment(x?.trash_dt).format('YY/MM/DD')}
                                            </td>
                                            <td>{statusName?.find(item => item?.idx*1 === x.status*1)?.title}</td>
                                            <td>{productCode}</td>
                                            <td>{moment(x?.update_dt).format('YY/MM/DD')}</td>
                                            <td>{x?.dong}</td>
                                            <td>{x?.jibun}</td>
                                            <td>{x?.area_private}</td>
                                            <td>{x?.sell_type}</td>
                                            <td>
                                            {x?.sell_type === '월세' ?
                                            <>{numFormat(x?.price_all)}/{numFormat(x?.price_month)}</>
                                            :
                                            <>{numFormat(x?.price_sell)}만원</>
                                            }
                                            </td>
                                            <td>{numFormat(x?.price_maintenance)}만원</td>
                                        </tr>
                                    );
                                })}
                                                                

                            </tbody>
                        </table>
                        {lists?.length === 0 &&
                            <div className='nolistArea'>
                                삭제된 매물이 없습니다.
                            </div>
                        }
                        <div ref={target} style={{ width: '100%', height: 1 }} />
                    </div>
                </div>
            </div>
        </Layout>
        {popflag === true &&
        <div className='PopupArea'>
            <div>
                <div className='PopupAreaBG' 
                    //onClick={() => { setpopflag(false);setthisdamdang(''); }}
                />
                <div className='PopupAreaContents'>
                    <div>
                        <div className="popTitle padding20">
                            <span >매물 복원</span>
                            <button
                                onClick={() => {
                                    setpopflag(false);
                                    setthisdamdang('');
                                }}
                            >
                                <img src="./images/icons/x.svg" width='20' />                                            
                            </button>
                        </div>
                        <div className="padding32">
                            <div className='popcontents'>
                                <div style={{ width: '100%' }}>
                                    <div>담당자변경</div>
                                    <div style={{ marginTop: 8 }}>
                                        <Select 
                                            setValues={(e) => {
                                                seterrormsg('');
                                                setthisdamdang(e);
                                            }}
                                            values={thisdamdang}
                                            selectData={( [{labels: '전체', values: ''}].concat(damdanglist) )}
                                        />  
                                    </div>
                                </div>
                            </div>
                            <div className='popcontents margint20'>
                                <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <b>{checkvalues?.length}개</b>의 매물을 복원하시겠습니까?
                                </div>
                            </div>
                            {errormsg &&
                                <p className="input_error margint10" style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <span></span>{errormsg}
                                </p>
                            }
                            <div className='popbuttons'>
                                <div>
                                    <Button
                                        disabled={true}
                                        buttonTxt={'아니오'}
                                        onPress={() => { setpopflag(false);setthisdamdang(''); }}
                                    />                                    
                                </div>
                                <div>
                                    <Button
                                        buttonTxt={'복원하기'}
                                        onPress={() => { 
                                            if(thisdamdang === ''){
                                                seterrormsg('변경할 담당자를 선택해주세요.');
                                                return;
                                            }
                                            if(checkvalues?.length === 0){
                                                seterrormsg('복원할 매물을 선택해주세요.');
                                                return;
                                            }

                                            productrestore();
                                        }}
                                    />                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        }        
        </>
    )
}
